import { hostConnectionState, invitationState2, joinState } from '.';
import config from '../../config.json';
import { getPeer, startJoin } from '..';
import { store } from '../../app/player/store';
import { initListeners } from '../../metrics';
import { joinInvitation, resolveJoinLink } from '../api';

let isListening = false;
export const initializeConnectionEvents = () => {
  if (isListening) return;
  isListening = true;
  joinState.reset();
  // knockState.reset(true);
  invitationState2.reset(true);
  hostConnectionState.reset();
  joinState.addListener(async (state) => {
    const status = state.state;
    if (status === 'idle') {
      console.log('Join state is idle');
      joinState.reset();
      // knockState.reset();
      invitationState2.reset();
      hostConnectionState.reset();
      getPeer()?.close();
      // join id is /j/:joinid
      const joinIdFromParams = window.location.pathname.split('/').pop();
      startJoin(joinIdFromParams);
    } else if (status === 'resolvingAlias') {
      console.log('Resolving alias');
      resolveJoinLink();
    } else if (status === 'chooseDeck') {
      console.log('Choose deck');
    } else if (status === 'chooseInvite') {
      console.log('Choose invite');
      console.log('Invites', invitationState2.currentState);
      if (Object.keys(invitationState2.currentState.invites).length === 1) {
        const invite = Object.values(invitationState2.currentState.invites)[0];
        if (invite) {
          invitationState2.updateState({
            ...invitationState2.currentState,
            selectedInvite: invite,
          });
          if (invite.type === 'instant') {
            joinInvitation(invite);
          }
        }
      }
    } else if (status === 'inQueue') {
      console.log('In queue');
      console.log('Invitation state', invitationState2.currentState);
      if (invitationState2.currentState.selectedInvite) {
        joinInvitation(invitationState2.currentState.selectedInvite);
      }
      // console.log('Knock state', knockState.currentState);
      // if (knockState.currentState.status === 'idle') {
      //   if (invitationState.currentState.selectedInvite) {
      //     getNewKnock();
      //   }
      // }
    } else if (status === 'connecting') {
      console.log('Connecting');
      // if (invitationState.currentState.selectedInvite) {
      //   if (invitationState.currentState.selectedInvite.instantConnect) {
      //     // Is instantly connecting
      //     getInstantExchange();
      //   }
      // }
    } else if (status === 'hostConnected') {
      window.history.pushState({ stage: 'hostConnected' }, '');
      console.log('Host connected');
    } else if (status === 'hostDisconnected') {
      console.log('Host disconnected');
      store.updatePlayerMode('spectator');
      if (document.fullscreenElement) document?.exitFullscreen();
      getPeer()?.close();
    } else if (status === 'playerDisconnected') {
      console.log('Player disconnected');
      store.updatePlayerMode('spectator');
      if (document.fullscreenElement) document?.exitFullscreen();
      getPeer()?.close();
    }
  });

  initListeners();

  hostConnectionState.addListener((state) => {
    if (state.status === 'connected') {
      joinState.updateState({
        state: 'hostConnected',
      });
    } else if (state.status === 'connecting') {
      console.log('Host connecting');
    } else if (state.status === 'idle') {
      console.log('Host idle');
    } else if (state.status === 'disconnected' || state.status === 'failed' || state.status === 'refused') {
      console.error('Host connection failed', state.status, joinState.currentState.state);
      if (state.status === 'refused' || state.status === 'failed') {
        joinState.updateState({
          state: 'hostDisconnected',
        });
      }
      if (state.status === 'disconnected' && joinState.currentState.state === 'connecting') {
        joinState.updateState({
          state: 'hostDisconnected',
        });
      }
      if (state.status === 'disconnected' && joinState.currentState.state === 'hostConnected') {
        joinState.updateState({
          state: 'playerDisconnected',
        });
      }
    }
  });
};

